module.exports = __webpack_public_path__ + "img/Metastasis-CECA_10X_CC.96d1cfa4.png";